<template>
  <v-img :src="imgComputed" height="100vh">
    <v-btn
      large
      rounded
      depressed
      to="/inicio"
      style="position: absolute; bottom: 5rem; left: 5rem;"
    >
      <v-icon left>mdi-chevron-left</v-icon>
      Regresar a inicio
    </v-btn>
  </v-img>
</template>
<style scoped>
.primary-pattern {
  height: 60vh;
  width: 100%;
  background-image: url("/imagenes/fondo-desenfoque-min.jpg");
  background-repeat: no-repeat;
}
.pt-header {
  padding-top: 120px;
}
.container {
  padding-left: 20%;
  padding-right: 20%;
}
ul {
  list-style: none;
}
</style>
<script>
import { mapState } from "vuex";
export default {
  data: () => ({}),
  mounted() {},
  computed: {
    ...mapState({
      campus: (state) => state.cities.campus,
      city_options: (state) => state.cities.city_options,
      city_selected: (state) => state.cities.city_selected,
      cities: (state) => state.cities.cities,
      vida: (state) => state.cities.vida,
      link_location: (state) => state.cities.link_location,
      link_information: (state) => state.cities.link_information,
    }),
    imgComputed() {
      if (this.$vuetify.breakpoint.mdAndUp)
        return "/imagenes/gracias/contacta.jpg";

      return "/imagenes/gracias/contacta-ver.jpg";
    },
  },
  methods: {},
};
</script>